function createShareUrl({ text, url }) {
  return `https://t.me/share/?text=${text}&url=${url}`
}

export default {
  id: 'telegram',
  title: 'Telegram',
  createShareUrl
}
